import { Link } from "react-router-dom";
import { BOM } from "../../../../services/definedMethod";

/*!*******************************************************************************!
  !***TAX GROUP API CONFIG                                                       ***!
  \*******************************************************************************/
export const taxGroupApi = {
  // Sales Transaction
  taxGroup: BOM.baseUrl("taxes/group"),
  newtaxGroup: BOM.baseUrl("fxtransactions/sell"),
  GetCurrencies: BOM.baseUrl("currencies"),
  GetLocalCurrencies: BOM.baseUrl("fxtransactions/localcurrency"),
  GetByAccountNo: BOM.baseUrl("savingsaccounts/findbyaccountno"),
  GetFxCharges: BOM.baseUrl("savingsproducts"),
  convertAmount: BOM.baseUrl("fxtransactions"),
};

/*!*******************************************************************************!
  !*** TAX GROUP LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const taxGroupLabel = {
  manageTaxGroups: "Manage Tax Group",
  newTaxGroup: "New Tax Group",
  taxGroupDetail: "Tax Group  Detail",
  editTaxGroup: "Edit Tax Group",
  name: "Name",
  startDate: "Start Date",
  endDate: "End Date",
  transactionDate: "Transaction Date",
  amountACY: "Amount ACY",
  accountNo: "Account No",
  chargeId: "Charge Id",
  currency: "Currency",
  date: "Date",
  taxGroupSetup: "Tax Group Setup",
  taxComponent: "Tax Component",
  taxComponentName: "taxComponents",
  taxComponentInfo: "Tax Components Information",
  taxComponents: "Tax Components",
  newTaxGroupMsg: "Tax Group was successfully created",
  editTaxGroupMsg: "Tax Group was successfully edited",
  generalInfo: "General Information",
  taxGroup: "Tax Group",
  viewTaxGroup: "Tax Group  Detail",
};

/*!*******************************************************************************!
    !*** TAX GROUP STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const taxGroupStatic = {
  manageTaxGroupItems: [{ title: taxGroupLabel.manageTaxGroups }],
  detailTaxGroupItems: [
    {
      title: <Link to="/prd1301">{taxGroupLabel.manageTaxGroups}</Link>,
    },
    { title: taxGroupLabel.taxGroupDetail },
  ],
  newTaxGroupItems: [
    {
      title: <Link to="/prd1301">{taxGroupLabel.manageTaxGroups}</Link>,
    },
    { title: taxGroupLabel.newTaxGroup },
  ],
  editTaxGroupItems: [
    { title: <Link to="/prd1301">{taxGroupLabel.manageTaxGroups}</Link> },
    { title: taxGroupLabel.editTaxGroup },
  ],
  monthList: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  transactionTypeData: [
    { label: "Purchase", value: "1" },
    { label: "Sale", value: "2" },
  ],
  taxTaxGroupItems: [{ title: taxGroupLabel.taxGroup }],
  viewTaxGroupBreadCrumbItems: [
    { title: <Link to="/view-tax-group">{taxGroupLabel.taxGroup}</Link> },
    { title: taxGroupLabel.taxGroupDetail },
  ],
};
